const MYROLS = 'MYROLS';
const ROLSANDPERMS = 'ROLSANDPERMS';

export const checkPerm = (perms) => {
  let perm = false;
  const rolsPerms = JSON.parse(sessionStorage.getItem(ROLSANDPERMS));
  const myRols = JSON.parse(sessionStorage.getItem(MYROLS));

  if (sessionStorage.getItem(MYROLS) !== null) {
    myRols?.forEach((myRol) => {
      rolsPerms?.forEach((rolPerm) => {
        if (myRol.nombre === rolPerm.rol) {
          if (rolPerm.permissions.indexOf(perms) !== -1) {
            perm = true;
          }
        }
      });
    });
  }

  return perm;
};
export const checkRol = (rolParam) => {
  const myRols = sessionStorage.getItem(MYROLS) ? JSON.parse(sessionStorage.getItem(MYROLS)) : [];

  return Boolean(myRols?.find((rol) => rol.nombre.includes(rolParam)));
};

export const checkUserPermission = (permission) => {
  let canView = false;
  const userRole = sessionStorage.getItem(MYROLS) ? JSON.parse(sessionStorage.getItem(MYROLS)) : [];
  const rolesPermissions = JSON.parse(sessionStorage.getItem(ROLSANDPERMS));

  if (rolesPermissions && rolesPermissions.length) {
    // Obtengo la data completa de los roles asociados al usuario
    const rolePermission = rolesPermissions.filter((rolPerm) =>
      userRole.some((usRol) => usRol.nombre.toLowerCase() === rolPerm.rol.toLowerCase())
    );

    if (rolePermission.length) {
      // Valido si el usuario tiene el permiso de acceso a la vista asociado a su rol
      const hasPermission = rolePermission.some((rolPerm) =>
        rolPerm.permissions.some((usRole) => permission.some((perm) => perm.includes(usRole)))
      );

      canView = hasPermission;
    }

    return canView;
  }

  return canView;
};
